import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/components/base-component';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent extends BaseComponent implements OnInit {


  register:any = {
    name: '',
    email: '',
    username: '',
    password: '',
    company: '',
    companyDocument: ''
  }

  constructor(){
    super();
  }

  ngOnInit(): void {
  }

  registerUser(){
    if(this.validadeFields()){

    }
  }

  validadeFields():boolean{

    let isValid = true;
    
    if(this.register.name == ''){
      this.register.name = null;
      isValid = false;
    }

    if(this.register.email == ''){
      this.register.email = null;
      isValid = false;
    }

    if(this.register.username == ''){
      this.register.username = null;
      isValid = false;
    }

    if(this.register.password == ''){
      this.register.password = null;
      isValid = false;
    }

    if(this.register.company == ''){
      this.register.company = null;
      isValid = false;
    }

    if(this.register.companyDocument == ''){
      this.register.companyDocument = null;
      isValid = false;
    }

    return isValid;
  }

}
